import Observable, { IObservableCallback } from './Observable';

type TEvent = 'top'
 | 'right'
 | 'bottom'
 | 'left'
 | 'tap';

interface ISwipe {
  addEventListener(_eventName: TEvent, _callback: IObservableCallback): void;
  removeEventListener(_eventName: TEvent, _callback: IObservableCallback): void;
}

class Swipe extends Observable implements ISwipe {
  static TOP = 'top';

  static RIGHT = 'right';

  static BOTTOM = 'bottom';

  static LEFT = 'left';

  static TAP = 'tap';

  private readonly element: HTMLElement;

  private touchstartX: number = 0;

  private touchstartY: number = 0;

  private touchendX: number = 0;

  private touchendY: number = 0;

  private timeStart: number = 0;

  private timeEnd: number = 0;

  constructor(elementClass: string) {
    super();

    this.element = document.querySelector(`.${elementClass}`) as HTMLDivElement;
    // @ts-ignore
    this.element.addEventListener('touchmove', this.handleTouchMove, { passive: false }, true);
    this.element.addEventListener('touchstart', this.handleTouchStart, { passive: false });
    this.element.addEventListener('touchend', this.handleTouchEnd, { passive: false });
  }

  private handleTouchStart = (event: TouchEvent): void => {
    const isButton = Boolean((event.target as HTMLElement).closest('button'));
    if (isButton) {
      return;
    }

    const touches = event.touches || [{}];

    this.timeStart = new Date().getTime();
    this.touchstartX = touches[0].screenX;
    this.touchstartY = touches[0].screenY;
  };

  private handleTouchMove = (event: TouchEvent): void => {
    // event.preventDefault();
  };

  private handleTouchEnd = (event: TouchEvent): void => {
    const isButton = Boolean((event.target as HTMLElement).closest('button'));
    if (isButton) {
      return;
    }

    const touches = event.changedTouches || [{}];

    this.timeEnd = new Date().getTime();
    this.touchendX = touches[0].screenX;
    this.touchendY = touches[0].screenY;
    // eslint-disable-next-line no-param-reassign
    // @ts-ignore
    // eslint-disable-next-line no-param-reassign
    event.touchTime = this.timeEnd - this.timeStart;
    this.handle(event);
  };

  private handle = (event: TouchEvent) => {
    let eventName: string = '';

    const horVector = this.touchendX - this.touchstartX;
    const verVector = this.touchendY - this.touchstartY;

    if (horVector < 0 && Math.abs(horVector) > Math.abs(verVector)) {
      eventName = Swipe.LEFT;
    }
    if (horVector > 0 && Math.abs(horVector) > Math.abs(verVector)) {
      eventName = Swipe.RIGHT;
    }

    if (verVector < 0 && Math.abs(horVector) < Math.abs(verVector)) {
      eventName = Swipe.BOTTOM;
    }
    if (verVector > 0 && Math.abs(horVector) < Math.abs(verVector)) {
      eventName = Swipe.TOP;
    }
    if (horVector === 0 && verVector === 0) {
      eventName = Swipe.TAP;
    }

    this.dispatchEvent(eventName, {
      originalEvent: event,
    });
  };

  public destroy = () => {
    this.element.removeEventListener('touchmove', this.handleTouchMove);
    this.element.removeEventListener('touchstart', this.handleTouchStart);
    this.element.removeEventListener('touchend', this.handleTouchEnd);
    this.removeAllListeners();
  };
}

export default Swipe;
